export default {"src":"/_next/static/media/locator-big-chacrol.dc8ee673.svg","height":35,"width":26};